import { render, staticRenderFns } from "./DocumentChangeStatusDialog.vue?vue&type=template&id=e4c10afa&scoped=true&lang=pug&"
import script from "./DocumentChangeStatusDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentChangeStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentChangeStatusDialog.vue?vue&type=style&index=0&id=e4c10afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c10afa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDivider,VIcon,VSpacer})
